module.exports = __webpack_public_path__ + "img/barbarian.c7e5a26e.png";